import { type } from '@/utils/type'

//////////////////////////////////////////////////////////////////
// CLIENT
/////////////////////////////////////////////////////////////////
export const CLIENT_ADD_PANIER =  type('CLIENT_ADD_PANIER')
export const CLIENT_CLEAR_PANIER = type('CLIENT_CLEAR_PANIER')
export const CLIENT_UPD_PANIER_ITEM_QTY = type('CLIENT_UPD_PANIER_ITEM_QTY')

export const CLIENT_ENSURE_CHECKOUT = type('CLIENT_ENSURE_CHECKOUT')
export const CLIENT_CHECKOUT_REQUEST = type('CLIENT_CHECKOUT_REQUEST')
export const CLIENT_CHECKOUT_FREE_REQUEST = type('CLIENT_CHECKOUT_FREE_REQUEST')
export const CLIENT_SET_PANIER_ADDRESS = type('CLIENT_SET_PANIER_ADDRESS')
